
export const pdfCssStyles = `
    .machineCardTemplate {
        background-color: #f8f9fa;
        width: 210mm;
        height: 297mm;
        border: 1px solid black;
        z-index: 1;
        display: flex;
        flex-direction: column;
    }
    .machineCardTemplate h3 {
        margin-bottom: 1rem;
        margin-left: 6rem;
        margin-right: 6rem;
        margin-top: 4rem;
        text-align: center;
        border-bottom: 1px solid black;
        font-weight: bold;
    }
    .title {
        margin-left: 6rem;
        margin-right: 6rem;
        display: flex;
        font-weight: bold;
        background-color: #dee2e6;
        padding: 0.5rem;
    }
    .title .rightTitle {
        padding: 0;
    }
    .title .leftTitle {
        width: 50%;
    }
    .componentDescription {
        width: 50%;
    }
    .serialNumber {
        padding: 0;
    }
    .machineCardRow {
        display: flex;
        align-items: center;
        border-bottom: 1px solid black;
        margin-left: 6.5rem;
        margin-right: 6rem;
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
    }
    .machineCardFooter {
        display: flex;
        border-top: 1px solid black;
        flex-direction: row;
        margin-top: auto;
        margin-bottom: 2rem;
        margin-left: 6rem;
        margin-right: 6rem;
        justify-content: space-between;
    }
    .machineCardFooter .logoContainer {
        margin-top: 2rem;
        margin-bottom: 2rem;
        flex: 1;
        text-align: right;
    }
    .machineCardFooter .logoContainer svg {
        height: 4rem;
    }
    .machineCardFooter .componentsDate {
        flex: 1;
    }
    .machineCardFooter .machineName {
        flex: 1;
        font-weight: bold;
        text-align: center;
    }
    `;

export const pdfLogoSvg = `
    <svg width="151" height="44" viewBox="0 0 151 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M141.593 32.0136H144.734V25.8268C144.734 23.4031 145.464 20.2141 148.826 20.2141C149.302 20.2141 150.063 20.3098 150.634 20.5011V16.9931C150.095 16.7699 149.619 16.738 149.143 16.738C147.081 16.738 145.527 18.0455 144.766 19.6719H144.67V17.1526H141.593V32.0136ZM129.38 28.1549C129.38 26.7198 130.966 26.1139 132.299 25.8268C133.441 25.5717 134.583 25.2528 135.376 24.8701V26.3052C135.376 27.9635 133.98 30.0045 131.664 30.0045C130.3 30.0045 129.38 29.3348 129.38 28.1549ZM130.808 32.492C132.965 32.492 134.71 31.4077 135.534 29.7494H135.598C135.598 30.6104 135.693 31.312 135.883 32.0455H139.056C138.77 30.8656 138.58 29.8451 138.58 27.3895V21.9362C138.58 18.4282 136.105 16.738 132.743 16.738C129.983 16.738 127.318 17.8861 126.398 20.9157L129.349 21.9362C129.856 20.1822 131.093 19.353 132.584 19.353C134.297 19.353 135.344 20.4054 135.344 21.6492C135.344 23.0524 134.012 23.148 130.871 23.8177C128.207 24.3918 125.923 25.5079 125.923 28.3143C125.923 31.0888 128.302 32.492 130.808 32.492ZM101.274 32.0136H104.415V24.1366C104.415 21.3621 106.001 19.7038 108 19.7038C110.093 19.7038 111.013 21.4897 111.013 24.041V32.0136H114.185V24.1366C114.185 21.3621 115.771 19.7038 117.77 19.7038C119.768 19.7038 120.752 21.5216 120.752 24.041V32.0136H123.924V22.6378C123.924 18.5558 121.291 16.7061 118.69 16.7061C116.977 16.7061 115.137 17.4396 113.71 19.7038H113.646C112.885 17.6309 110.95 16.7061 109.11 16.7061C107.27 16.7061 105.462 17.6309 104.383 19.5125H104.351V17.1207H101.274V32.0136ZM94.9299 32.0136H98.0704V10.615H94.9299V32.0136ZM82.7168 28.1867C82.7168 26.7517 84.3029 26.1457 85.6353 25.8587C86.7773 25.6036 87.9193 25.2847 88.7123 24.902V26.3371C88.7123 27.9954 87.3166 30.0364 85.0008 30.0364C83.6368 30.0045 82.7168 29.3348 82.7168 28.1867ZM84.1443 32.492C86.3014 32.492 88.0462 31.4077 88.871 29.7494H88.9344C88.9344 30.6104 89.0296 31.312 89.2199 32.0455H92.3921C92.1066 30.8656 91.9163 29.8451 91.9163 27.3895V21.9362C91.9163 18.4282 89.442 16.738 86.0794 16.738C83.3195 16.738 80.6549 17.8861 79.7349 20.9157L82.6851 21.9362C83.1927 20.1822 84.4298 19.353 85.9208 19.353C87.6338 19.353 88.6806 20.4054 88.6806 21.6492C88.6806 23.0524 87.3483 23.148 84.2078 23.8177C81.5431 24.3918 79.2591 25.5079 79.2591 28.3143C79.2274 31.0888 81.6065 32.492 84.1443 32.492ZM62.8904 32.0136H66.2529V25.4123C67.046 24.5512 67.8391 23.6902 68.6004 22.8291H68.6321C70.8844 25.9225 73.1684 28.984 75.4207 32.0455H79.4812C76.6261 28.123 73.7394 24.2004 70.8844 20.2779V20.246C73.6125 17.2164 76.3406 14.1867 79.0688 11.1571H75.1352C72.2167 14.41 69.2666 17.6628 66.3798 20.9157H66.2847V11.1571H62.9221V32.0136H62.8904Z" fill="#2C112D"/>
    <path d="M55.055 0.856445H32.4688C32.4688 0.856445 30.8509 6.75622 27.298 11.5717C23.4914 16.6742 17.7179 20.7243 17.4641 20.9795C28.0911 20.9795 41.8903 22.7972 55.055 0.856445Z" fill="#F30000"/>
    <path d="M17.4324 0.888428V21.0114C12.9595 21.0114 -0.205242 18.2369 0.809872 0.888428" fill="#F30000"/>
    <path d="M55.055 43.1116H32.4688C32.4688 43.1116 30.8509 37.2119 27.298 32.3964C23.4914 27.2939 17.7179 23.2438 17.4641 22.9886C28.0911 22.9886 41.8903 21.1709 55.055 43.1116Z" fill="#F30000"/>
    <path d="M17.4324 43.0798V22.9568C12.9595 22.9568 -0.205242 25.7313 0.809872 43.0798" fill="#F30000"/>
    </svg>  
`;

export const formPdfTemplate = (dynamicId: string) => {
    return `  
        <!DOCTYPE html>
        <html>
        <head>
            <meta charset="UTF-8">
            <title>Machine Card</title>
            <style>
            @page {
                    size: A4;
                    margin: 20mm;
                }
                ${pdfCssStyles}
            </style>
        </head>
        <body>
            <div class="machineCardTemplate" id=${dynamicId}>
                <h3>Machine card</h3>
                <div class="title">
                    <div class="leftTitle">Description</div>
                    <div class="rightTitle">Serial Number:</div>
                </div>
                {{#components}}
                <div class="machineCardRow">
                    <span class="componentDescription">{{description}}</span>
                    <span class="serialNumber">{{serial_number}}</span>
                </div>
                {{/components}}
                <div class="machineCardFooter">
                    <div class="componentsDate">{{date}}</div>
                    <div class="machineName">{{selectedEquipment.serial_number}}</div>
                    <div class="logoContainer">{{{logo}}}</div>
                </div>
            </div>
        </body>
        </html>
    `;
};